import { render, staticRenderFns } from "./LuExciseTaxTypesGrid.vue?vue&type=template&id=19bcaef6&"
import script from "./LuExciseTaxTypesGrid.vue?vue&type=script&lang=js&"
export * from "./LuExciseTaxTypesGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports